import { applyMiddleware, createStore } from "redux";
import reducer from "./reducer";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { createLogger } from "redux-logger";
import { localStorageMiddleware } from "./middleware";
import throttle from "lodash/throttle";

const getMiddleware = () => {
    if (process.env.NODE_ENV === "production") {
        return applyMiddleware(localStorageMiddleware);
    } else {
        const logger = createLogger({
            predicate: (getState, action) => !action.type.startsWith("@@redux-form")
        });
        return applyMiddleware(localStorageMiddleware, logger);
    }
};



const lsKey = "state";
const loadState = () => {
    try {
        const serializedState = window.localStorage.getItem(lsKey);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch(_) {
        return undefined;
    }
};

const store = createStore(reducer, loadState(), composeWithDevTools(getMiddleware()));

store.subscribe(throttle(() => {
    try {
        const {form} = store.getState();
        window.localStorage.setItem(lsKey, JSON.stringify({form}));
    } catch(err) {
        console.error("cannot save store to the localStorage", err);
    }
}, 1000));

export default store;



// WEBPACK FOOTER //
// ./src/store.js